// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/.store/css-loader@3.6.0/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".search-box{flex-wrap:wrap}.goods-list{border:1px dotted #ddd;background-color:#f5f5f5;min-height:50px;max-height:300px;overflow-y:auto}.goods-list .item{padding:10px;line-height:1;cursor:pointer}.goods-list .item:hover{background-color:#fff}", ""]);
// Exports
module.exports = exports;
